export enum CustomGroupRowInnerComponentActions {
    UPDATE_COLUMN_WIDTH_BY_OPERATION = 'UPDATE_COLUMN_WIDTH_BY_OPERATION',
    UPDATE_COLUMN_WIDTH_BY_SCROLL = 'UPDATE_COLUMN_WIDTH_BY_SCROLL',
    UPDATE_COLUMN_AGGFUNC_VALUE = 'UPDATE_COLUMN_AGGFUNC_VALUE'
}
